import { API_PATH } from '@/shared/constants/api'
import { apiRequest } from '@/shared/helpers/api-request'
import type { UserAccount } from '@/shared/types/global.types'

export function getUserAccount(token: string): Promise<UserAccount> {
  return apiRequest<UserAccount>(API_PATH.USER_ACCOUNT, token)
}

export async function updateUserAccount(
  token: string,
  body: {
    accountHolderName?: string
    accountNumber: string
    routingNumber: string
    bankName: string
    accountType: 'checking' | 'saving'
  },
): Promise<void> {
  await apiRequest<void>(API_PATH.USER_ACCOUNT, token, 'PUT', body)
}
